module.exports = {
      id: "apple-usage",
      viewBox: "0 0 16 20",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#apple",
      toString: function () {
        return this.url;
      }
    }